import Salesform from "./Salesform";
import Header from "../../../../Components/Header";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";


const SalesInvoiceCreate = () => {
  const location = useLocation();
  const delivery_note_id = location.state?.deliveryNoteId;
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				    <title>Sales Invoice - Create</title>
			  </Helmet>
      <Header  />
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <Salesform  delivery_note={delivery_note_id}/>
      </div>
    </div>
  );
};

export default SalesInvoiceCreate;
